<!-- @format -->
<script lang="ts">
  import { nl2br } from './utils';

  export let menu;
  export let store;
  export let href = "/";
  export let t;

  let showedMore = false;

  function showMoreHandler() {
    return (showedMore = !showedMore);
  }
</script>

<div class="col-lg-4 col-12">
  <div class="menu-card" id={menu.store.id} class:showed-more-menu={showedMore}>
    <a {href} class="d-block">
      <div class="logo text-uppercase text-center">
        {#if store?.logoURL}
          <img src={store.logoURL} alt={store.name} />
        {/if}
      </div>
    </a>
    <div class="lunch-menu" class:showed-more-menu={showedMore}>
      <a {href} class="store-name mb-3 fs-5 link fw-bold">{menu.store.name}</a>
      <h6 class="fw-bolder">{t`lunch-time`}: {menu.lunchTime}</h6>
      {@html nl2br(menu.generalInformation)}
      <hr> 
      {@html nl2br(menu.lunchMenu)}
    </div>
    <div class="show-more-button py-3">
      <button
        on:click={showMoreHandler}
        type="button"
        class="show-more purple-outline-button mx-auto d-block fit-content"
      >
        {showedMore ? t`show-less` : t`show-more`}
      </button>
    </div>
  </div>
</div>

<style lang="scss">
  a {
    text-decoration: none;
    color: #000;
    font-size: 20px;
  }
  .store-name {
    color: var(--color-accent-primary-text);
    text-decoration: none;
    display: block;
  }
  .store-name:hover {
    color: var(--color-black);
  }
  .logo {
    width: 100%;
    padding: 1.5rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    border: 1px solid var(--color-accent-secondary);
    img {
      max-width: 80%;
      max-height: 80%;
      position: absolute;
      padding: 1rem;
    }
  }
  .logo::after {
    content: '';
    display: block;
    padding-bottom: 75%;
  }
  .menu-card {
    width: 100%;
    margin-bottom: 2rem;
    height: 600px;
    overflow: hidden;
    border: 3px solid var(--color-accent-secondary);
    @media screen and (min-width: 768px) and (max-width: 991px) {
      height: 885px;
    }
    @media screen and (min-width: 576px) and (max-width: 767px) {
      height: 750px;
    }
  }
  .lunch-menu {
    padding: 2rem 2rem 0 2rem;
    word-break: break-word;
    background-color: var(--color-accent-secondary);
    height: 200px;
    overflow: hidden;
    h6 {
      font-size: 16px;
    }
    @media screen and (min-width: 1400px) {
      height: 175px;
    }
    @media screen and (min-width: 1200px) and (max-width: 1399px) {
      height: 220px;
    }
    @media screen and (min-width: 576px) and (max-width: 1199px) {
      height: 265px;
    }
  }
  .show-more-button {
    background-color: var(--color-accent-secondary);
  }
  .showed-more-menu {
    height: auto;
    overflow: none;
    background-color: var(--color-accent-secondary-light);
  }
</style>